<!-- GUÍA DE LIQUIDACIÓN (GUI-01..10). Solo clases de la consola (kb-*). A 390 px todo apila en una columna. -->
<div [ngClass]="pagina ? 'kb-page kb-liq' : 'space-y-4'">

  <h1 class="kb-page-title !text-xl" *ngIf="pagina"><i class="fas fa-book-open text-[0.85em] text-muted-foreground" aria-hidden="true"></i> Guía de la liquidación</h1>

  <!-- ══ Tu rol ══ -->
  <div class="flex flex-wrap items-center gap-2" role="group" aria-label="Tu rol en la guía">
    <span class="text-sm text-muted-foreground">Tu guía:</span>
    <button type="button" *ngFor="let r of roles" class="kb-btn kb-btn-sm"
            [ngClass]="rol === r.id ? '!bg-foreground !text-background' : 'kb-btn-outline'"
            [attr.aria-pressed]="rol === r.id" (click)="elegirRol(r.id)">{{ r.nombre }}</button>
  </div>

  <div class="grid grid-cols-1 gap-4 lg:grid-cols-2">

    <!-- ══ Video ══ -->
    <div class="kb-card">
      <div class="kb-card-header">
        <h2 class="kb-card-title">Video · {{ nombreRol }}</h2>
        <p class="kb-card-desc">Tu parte del proceso, de punta a punta, en unos siete minutos.</p>
      </div>
      <div class="kb-card-body">
        <div class="aspect-video w-full overflow-hidden rounded-md bg-muted" *ngIf="videoUrl">
          <iframe class="h-full w-full" [src]="videoUrl" allow="autoplay; fullscreen" allowfullscreen loading="lazy"
                  [attr.title]="'Video de la guía para ' + nombreRol"></iframe>
        </div>
        <div class="kb-aviso-info" *ngIf="!videoUrl">
          <i class="fas fa-film" aria-hidden="true"></i>
          <span>El video de esta guía está en preparación. Mientras tanto, las seis etapas y las preguntas de abajo te acompañan.</span>
        </div>
      </div>
    </div>

    <!-- ══ El proceso en seis pasos ══ -->
    <div class="kb-card">
      <div class="kb-card-header">
        <h2 class="kb-card-title">El proceso en seis pasos</h2>
        <p class="kb-card-desc">Los marcados son donde participas como {{ nombreRol }}.</p>
      </div>
      <div class="kb-card-body">
        <ol class="space-y-2">
          <li *ngFor="let p of pasos; let i = index" class="flex items-start gap-3 rounded-md border border-border px-3 py-2"
              [class.bg-muted]="participa(p.roles)">
            <span class="kb-badge" [ngClass]="participa(p.roles) ? 'kb-badge-marca' : 'kb-badge-neutro'">{{ i + 1 }}</span>
            <span class="min-w-0">
              <span class="block text-sm font-medium">{{ p.titulo }}</span>
              <span class="block text-xs text-muted-foreground">{{ p.quien }}</span>
            </span>
            <span class="kb-badge kb-badge-exito ml-auto shrink-0" *ngIf="participa(p.roles)">Tú</span>
          </li>
        </ol>
      </div>
    </div>
  </div>

  <!-- ══ Los procesos en dibujos (GUI-12) ══ -->
  <div class="space-y-3">
    <div>
      <h2 class="kb-card-title">Los procesos en dibujos</h2>
      <p class="kb-card-desc">Cada proceso con la forma que mejor lo explica. Estos son los de {{ nombreRol }}.</p>
    </div>

    <app-liquidacion-guia-diagramas [rol]="rol"></app-liquidacion-guia-diagramas>
  </div>

  <!-- ══ Preguntas frecuentes ══ -->
  <div class="kb-card">
    <div class="kb-card-header">
      <h2 class="kb-card-title">Preguntas frecuentes</h2>
      <p class="kb-card-desc">Busca una palabra: tanda, firma, feriado, comprobante…</p>
    </div>
    <div class="kb-card-body space-y-3">
      <input type="search" class="kb-input" [(ngModel)]="texto" placeholder="Busca en las preguntas" aria-label="Buscar en las preguntas frecuentes">
      <div class="flex flex-wrap gap-2" role="group" aria-label="Filtro de preguntas">
        <button type="button" class="kb-btn kb-btn-sm" [ngClass]="!todas ? '!bg-foreground !text-background' : 'kb-btn-outline'" [attr.aria-pressed]="!todas" (click)="todas = false">De mi rol</button>
        <button type="button" class="kb-btn kb-btn-sm" [ngClass]="todas ? '!bg-foreground !text-background' : 'kb-btn-outline'" [attr.aria-pressed]="todas" (click)="todas = true">Todas</button>
      </div>

      <details *ngFor="let p of visibles; trackBy: porId" class="rounded-md border border-border px-3 py-2">
        <summary class="cursor-pointer text-sm font-medium">{{ p.pregunta }}<span class="kb-badge kb-badge-neutro ml-2" *ngIf="p.comercio">Lo que ve el comercio</span></summary>
        <p class="mt-2 text-sm text-muted-foreground">{{ p.respuesta }}</p>
      </details>

      <div class="kb-aviso-info" *ngIf="!visibles.length">
        <i class="fas fa-search" aria-hidden="true"></i>
        <span>No encontramos esa pregunta{{ todas ? '' : ' para tu rol' }}. Escríbela en «Haz tu pregunta», aquí abajo, y la sumamos a la lista.</span>
      </div>
    </div>
  </div>

  <!-- ══ Haz tu pregunta ══ -->
  <div class="kb-card">
    <div class="kb-card-header">
      <h2 class="kb-card-title">Haz tu pregunta</h2>
      <p class="kb-card-desc">Si no está arriba, escríbela. Queda registrada con tu nombre y tu rol; la respondemos y la sumamos a la lista.</p>
    </div>
    <div class="kb-card-body space-y-3">
      <textarea class="kb-input" rows="3" maxlength="1000" [(ngModel)]="textoPregunta" aria-label="Tu pregunta"></textarea>
      <div><button type="button" class="kb-btn !bg-foreground !text-background" [disabled]="!puedeEnviar" (click)="preguntar()">Enviar pregunta</button></div>
      <div class="kb-aviso-info" *ngIf="exito" role="status"><i class="fas fa-check-circle" aria-hidden="true"></i><span>{{ exito }}</span></div>
      <div class="kb-aviso-info" *ngIf="errorPregunta" role="status"><i class="fas fa-info-circle" aria-hidden="true"></i><span>{{ errorPregunta }}</span></div>
    </div>
  </div>

  <!-- ══ Preguntas por responder (solo con el permiso liquidacion.guia_responder, GUI-08) ══ -->
  <div class="kb-card" *ngIf="esOwner">
    <div class="kb-card-header">
      <h2 class="kb-card-title">Preguntas por responder</h2>
      <p class="kb-card-desc">Las que escribió el equipo. Al responderla y sumarla a la lista, márcala.</p>
    </div>
    <div class="kb-card-body space-y-2">
      <div class="kb-aviso-info" *ngIf="errorPendientes"><i class="fas fa-info-circle" aria-hidden="true"></i><span>{{ errorPendientes }}</span></div>
      <p class="text-sm text-muted-foreground" *ngIf="!pendientes.length && !errorPendientes">No hay preguntas por responder.</p>
      <div *ngFor="let q of pendientes; trackBy: porId" class="flex flex-col gap-2 rounded-md border border-border px-3 py-2 sm:flex-row sm:items-center sm:justify-between">
        <span class="min-w-0 text-sm">
          {{ q.texto }}
          <span class="block text-xs text-muted-foreground">{{ q.usuario_nombre || q.usuario?.nombre }} · {{ q.rol }}</span>
        </span>
        <button type="button" class="kb-btn kb-btn-outline kb-btn-sm shrink-0" [disabled]="marcando === (q._id || q.id)" (click)="marcarRespondida(q)">Marcar respondida</button>
      </div>
    </div>
  </div>
</div>
